
import { Editor, EditorContent } from '@tiptap/vue-2'
import { Document } from '@tiptap/extension-document'
import { Text } from '@tiptap/extension-text'
import { HardBreak } from '@tiptap/extension-hard-break'
import { History } from '@tiptap/extension-history'
import { Paragraph } from '@tiptap/extension-paragraph'

export default {
    name: 'TipTapEditor',
    components: {
        EditorContent
    },
    props: {
        value: {
            type: String,
            default: () => ''
        },
        error: {
            type: String,
            default: () => null
        },
        disabled: {
            type: Boolean,
            default: () => false
        },
        extensions: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            editor: null
        }
    },
    computed: {
        isNotArabic () {
            return this.editor?.getText().length && !/^[\u0621-\u064A0-9 ]+$/.test(this.editor.getText().charAt(0))
        },
        editorClasses () {
            const classes = 'text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-200 px-3 py-2 rounded-lg border rounded-lg shadow-sm overflow-y-scroll overscroll-none max-h-28'.split(' ')
            if (this.error) {
                classes.push('border-red-300')
            }

            return classes.join(' ')
        }
    },
    watch: {
        value (value) {
            if (this.editor.getHTML() === value) {
                return
            }

            this.editor.commands.setContent(value, false)
        },
        error () {
            this.editor.setOptions({
                editorProps: {
                    attributes: {
                        class: this.editorClasses
                    }
                }
            })
        },
        disabled () {
            this.editor.setEditable(!this.disabled)
        }
    },

    mounted () {
        this.editor = new Editor({
            editorProps: {
                attributes: {
                    class: this.editorClasses,
                    disabled: this.disabled
                },
                handleKeyDown: (view, event) => {
                    // TODO: find a way to run this code after other extensions
                    // if (!event.shiftKey && event.key === 'Enter') {
                    //     this.$emit('enter', this.editor.getHTML())
                    //     return true
                    // }
                }
            },
            content: this.value,
            editable: !this.disabled,
            onUpdate: () => {
                this.$emit('input', this.editor.getHTML())
            },
            extensions: [
                Document,
                Paragraph,
                Text,
                HardBreak,
                History.configure({
                    depth: 5
                }),
                ...this.extensions
            ]
        })
    },
    beforeDestroy () {
        this.editor.destroy()
    }
}
